import React from 'react'
import styled from '@emotion/styled'

const Center = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 75vh;
  padding: 0 1rem;
`

const RouteErrorsNotFound = () => (
  <Center>
    <h1>404</h1>
    <h3>The route you are trying to access is not found</h3>
  </Center>
)

export default RouteErrorsNotFound



// WEBPACK FOOTER //
// ./src/routes/errors/404.js